import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MasterService } from 'src/app/services/master.service';
import { SecurityLevelsApiService } from 'src/app/services/security-levels-api.service';
import { Module } from 'src/app/interfaces/module';
import { SecurityLevel } from 'src/app/interfaces/security-level';
import { AuthenticationService } from '../../../../services/authentication.service';
@Component({
  selector: 'edit_module_dialog',
  templateUrl: './edit_module_dialog.component.html',
  styleUrls: ['./edit_module_dialog.component.css'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
})
export class ModuleEditDialogComponent implements OnInit {
  form: any;
  ID: number;
  selectedFile: File | null = null;
  uploadProgress: number = 0;
  isUploading: boolean = false;
  module: Module;
  resultMessage: string = '';
  security_levels: SecurityLevel[] = [];
  description: string;
  archivesign : boolean;
  inputparametrs: string = '';
  commandline: string = '';
  short_title: string = '';
  selected_security_level_name: string ='';
  security_level: SecurityLevel = { ID: -1, ShortTitle: '' };

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModuleEditDialogComponent>,
    private security_levels_api: SecurityLevelsApiService,
    private modules_api: MasterService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.module = data.module;
    this.ID = this.module.ID;
    this.archivesign= this.module.ArchiveSign;
    this.description = this.module.Description;
    this.short_title = this.module.ShortTitle;
    this.commandline = this.module.CommandLine;
    this.inputparametrs = this.module.InputParametrs;
    this.selected_security_level_name = this.module.SecurityLevel;
  }

  ngOnInit() {
    this.form = this.fb.group({
      ID:[this.ID, []],
      short_title: [this.short_title, []],
      description: [this.description, []],
      security_level: [this.security_level, []],
      inputparametrs: [this.inputparametrs, []],
      commandline: [this.commandline, []],
      archivesign: [this.archivesign, []],
    });
    this.security_levels_api.getSecurityLevels().subscribe((res) => {
      this.security_levels = res;
      console.log('SECURITY_LEVEL: '+this.selected_security_level_name);
      let tmp = this.security_levels.find(
        (x) => x.ShortTitle === this.selected_security_level_name
      );

      if (tmp !== undefined) {
        this.form.get('security_level').setValue(tmp);
      }
    });
    this.dialogRef.updateSize('80%', '100%');

  }

  save() {
    this.modules_api
      .Update_module(this.form?.value)
      ?.subscribe((res) => {});

    this.dialogRef.close(this.form?.value);
  }

  
   file_upload(): void {
  
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    //fileInput.accept = '.py,.bin,.exe'; // Ограничиваем типы файлов
    fileInput.style.display = 'none';
    
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.uploadModuleFile(file);
      }
    };
    fileInput.click();
  }
  
  
  uploadModuleFile(file: File): void {
    this.isUploading = true;
    this.uploadProgress = 0;
    
    this.modules_api.Upload_module_file(file).subscribe({
      next: (response) => {
        
        this.isUploading = false;
        
        // Показываем уведомление об успехе
        this.resultMessage='    Файл успешно загружен!';
      },
      error: (error) => {
        console.error('Ошибка загрузки:', error);
        this.isUploading = false;
        this.resultMessage=' Ошибка загрузки файла: '+ error.error?.error || error.message;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
